<template>
  <div class="view-memberkit">
    <div class="mb-6">
      <h5 class="text-semibold">Memberkit</h5>
      <small>Integre sua área de membros da plataforma Memberkit ao ZeusPay</small>
    </div>
    <snow-data-table-header
      @add="add"
      :datePicker="false"
      @searching="searching"
      :filters="false"
    />

    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <template v-else>
      <snow-data-table :data="integrationList" :columns="membersColumns">
        <template #no-content-actions>
          <snow-button
            icon="ph ph-plus"
            text="Adicionar integração"
            @click="modal = true"
          />
        </template>
      </snow-data-table>
    </template>
    <div class="d-flex justify-content-end mt-4">
      <snow-paginator
        v-model="page"
        :pagination="pagination"
        @change-page="dispatch"
      />
    </div>

    <integration-modal
      v-model="modal"
      :isEdit="!!integrationToEdit"
      title="Memberkit"
      link="https://memberkit.com/"
    >
      <memberkit-modal
        :integrationToEdit="integrationToEdit"
        @close="modal = false"
        @update-list="dispatch"
      />
    </integration-modal>
  </div>
</template>
<script>
import MemberkitModal from "@/components/tools/modals/member-area/Memberkit.vue";

import IntegrationsMixin from "@/mixins/integration";

export default {
  mixins: [IntegrationsMixin],
  components: {
    MemberkitModal
  },
  data() {
    return {
      integration: "memberkit",
      breadcrumbs: [
        { title: "Ferramentas", link: "tools" },
        { title: "Área de membros", link: "tools-member-area" },
        { title: "Memberkit" }
      ]
    };
  },
  computed: {
    membersColumns() {
      return [
        {
          name: "Produto",
          field: "product_name"
        },
        {
          name: "ID de turma",
          field: "classroom"
        },
        {
          name: "ID de assinatura",
          field: "membership_level_id"
        },
        {
          name: "Status",
          field: "status",
          transform: value => (value ? "Ativo" : "Inativo"),
          color: value => (value ? "green" : "negative"),
          type: "tag"
        },
        {
          type: "menu",
          options: this.actions
        }
      ];
    }
  },
  methods: {
    actions(item) {
      return [
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: item.status ? "Desativar" : "Ativar",
          class: item.status ? "text-danger" : "text-success",
          click: this.changeStatus
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text:
              "Deseja mesmo excluir esta integração? Não enviaremos mais os leads para esta segmentação.",
            icon: "ph ph-trash",
            buttonText: "Sim, excluir",
            action: this.submitDelete,
            secondaryButtonText: "Não, cancelar"
          }
        }
      ];
    }
  }
};
</script>
